import api from "../../../services/api";

export interface EventByDate {
  id: number;
  title: string;
  description: string;
  source: string;
  channel:string;
  location: string;
  start_at: string;
  end_at: string;
}

export type EventsMonthResponse = EventByDate[];

export async function getEventsMonthService(month: string): Promise<EventsMonthResponse> {
  // month format: "2025-08" (YYYY-MM)
  const res = await api.get<EventsMonthResponse>(`/api/key_points/by-month?month=${month}`);
  return res.data;
}